import React, { useState, useEffect } from 'react';
import Button from '../../@base/Button';
import DialogNotification from '../../DialogNotification/DialogNotification';
import TagInput from '../../TagsInput/TagsInput';

import faqComponentStyle from './FAQComponent.module.css';

/** Componente de resposta automática */
const WordlistsConfiguration = (props) => {
  const [showWordsEditor, setShowWordsEditor] = useState(false);
  const [wordsState, setWordsState] = useState(null);
  const words = props.parameter;

  useEffect(() => {
    if (props.parameter) {
      let updatedWordsState = words.value.split(',').filter((v) => v !== '');
      updatedWordsState = updatedWordsState.map((t, i) => ({ id: `${i}`, text: t }));
      setWordsState(updatedWordsState);
    }
  }, [props.parameter]);

  useEffect(() => {
    if (!wordsState) return;
    const _value = wordsState.map((t) => t.text).join(',');

    if (_value === words.value) return;
    props.updateParameter({
      ...words,
      value: _value,
    });
  }, [wordsState]);

  return (
    <>
      {showWordsEditor
        ? (
          <DialogNotification
            color="info"
            okAction={() => { setShowWordsEditor(false); }}
            scrimAction={() => { }}
            title={`Editar lista de ${props.name}`}
            content={(
              <>
                <p>
                  {props.parameter.parameter.hint}
                </p>
                <TagInput
                  classes={faqComponentStyle.TagInput}
                  value={wordsState}
                  onChange={(e) => setWordsState(e)}
                  placeholder="Nova palavra"
                  mandatory={props.parameter.parameter.mandatory}
                />
              </>
            )}
          />
        )
        : null}

      <div className="item-list">
        <div className="row">
          <div style={{
            display: 'block',
            width: '80px',
          }}
          >
            {props.name}
            :
          </div>
          <div style={{
            display: 'block',
            width: 'calc(95% - 80px)',
          }}
          >

            <div
              className="row"
              style={{
                alignItems: 'center',
              }}
            >
              <Button small primary classes="mr-2" onClick={() => setShowWordsEditor(true)}>
                <small>Editar</small>
              </Button>
              {wordsState === null ? 0 : wordsState.length}
              {' '}
              termos
            </div>
          </div>
          <div />
        </div>
        <div />
      </div>
    </>
  );
};

export default WordlistsConfiguration;
